import React from 'react';
import * as FiIcons from 'react-icons/fi';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import Brand from './Brand';
import { navItems } from '../data/siteData';

const { FiArrowUpRight } = FiIcons;
const bookingUrl = 'https://optmise.com';

function Sidebar({ activeSection, onNavigate }) {
  return (
    <aside className="sidebar">
      <Brand />

      <nav className="side-nav" aria-label="Main navigation">
        {navItems.map((item) => (
          <button
            className={`nav-item ${activeSection === item.target ? 'active' : ''}`}
            key={item.target}
            onClick={() => onNavigate(item.target)}
            type="button"
          >
            <SafeIcon icon={item.icon} />
            <span style={{ fontSize: '15px' }}>{item.label}</span>
            {activeSection === item.target && <motion.i layoutId="nav-dot" />}
          </button>
        ))}
      </nav>

      <div className="sidebar-card">
        <button type="button" onClick={() => { window.open(bookingUrl, '_blank', 'noopener,noreferrer'); }}>
          Sign Up
          <SafeIcon icon={FiArrowUpRight} />
        </button>
      </div>

      <p className="sidebar-foot">© 2025 Growth Sparrow</p>
    </aside>
  );
}

export default Sidebar;